import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { ENABLE_HUMAN_REVIEW } from "shared/SharedConstants";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import ProjectTeamSettings from "src/components/app/ProjectSettings/ProjectTeamSettings";
import ContentPanel from "src/components/common/ContentPanel/ContentPanel";
import Typography from "src/components/common/Typography/Typography";
import DocLink from "src/components/docs/DocLink/DocLink";
import { usePortal } from "src/lib/contexts/PortalContext";
import { useExtracted } from "#i18n";

// Beta: only loaded while ENABLE_HUMAN_REVIEW is on, so disabled builds ship none of it.
const HumanReviewersPanel = ENABLE_HUMAN_REVIEW
  ? lazy(() => import("src/components/app/HumanReview/HumanReviewersPanel"))
  : () => null;

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/members")({
  component: MembersPage,
});

function MembersPage() {
  const t = useExtracted();
  const { selectedProject } = usePortal();
  return (
    <PortalPage className="max-w-6xl">
      <PortalPage.Header>
        <PortalPage.Heading>
          <PortalPage.Title>{t("Members")}</PortalPage.Title>
          <PortalPage.Description>
            {t("Manage project access and invite your team.")}
          </PortalPage.Description>
          <PortalPage.Docs>
            <DocLink topic="project-collaboration" />
          </PortalPage.Docs>
        </PortalPage.Heading>
      </PortalPage.Header>
      <PortalPage.Content>
        {selectedProject ? (
          <>
            <ProjectTeamSettings key={selectedProject.id} />
            {/* Its own boundary, so the team settings hydrate without waiting for this chunk. */}
            <Suspense fallback={null}>
              <HumanReviewersPanel key={`reviewers-${selectedProject.id}`} />
            </Suspense>
          </>
        ) : (
          <ContentPanel.Content>
            <Typography tone="muted">{t("Select a project to manage members.")}</Typography>
          </ContentPanel.Content>
        )}
      </PortalPage.Content>
    </PortalPage>
  );
}
